import React from 'react';
import { Text, View } from 'react-native';

//= ========================================================================

const MyGreenCircle = ({
  value, marginLeft, marginTop, hideCircle,
}) => {
  const myStyles = {
    circleContainer: {
      width: 30,
      height: 30,
      marginTop,
      marginLeft,
      borderRadius: 15,
      backgroundColor: '#00d820',
      position: 'absolute',
    },
    circleText: {
      marginTop: 6,
      width: 30,
      fontFamily: 'Rubik-Medium',
      fontSize: 16,
      color: '#ffffff',
      textAlign: 'center',
      position: 'absolute',
    },
  };
  return (
    <View style={!hideCircle && myStyles.circleContainer}>
      {!hideCircle && <Text style={myStyles.circleText}>{value}</Text>}
    </View>
  );
};
export default MyGreenCircle;
